import axios from "axios";
import { apiUrl } from "../../App";

export async function getCommunityExcludedUsersUseCase(
  communityId: string,
  userIds: string[]
) {
  const userIdsString = userIds.join(",");

  return await axios.get(
    `${apiUrl}/admin/rankings/excluded-users/${communityId}/filter-out?ids=${userIdsString}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    }
  );
}
